import { differenceInHours } from "date-fns";
import { css, html, LitElement, nothing, PropertyValues, TemplateResult } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { TerminalsModel } from "../../../src/models/terminals-model";
import { FiSubView, UiElements, UiStateModel, UiStateModelParam } from "../../../src/models/ui-state-model";
import { VoyagePlan } from "../../../src/models/vessel-planning-model";
import { VoyFleetAlarmModel } from "../../../src/models/voy-fleet-alarm-model";
import { PlanSource, VoyagePlansModel } from "../../../src/models/voyage-plans-model";
import { VoyageSchedulesModel } from "../../../src/models/voyage-schedules-model";
import { CoordinatesUtils } from "../../../src/utils/coordinates-utils";
import { FormatDateToLocalTime, GetFormattedDateDayMonthTimeNoYear, GetUTCTimestamp, prettyTimelapsed, getFormattedDateUTC, GetFormattedLocalDateString } from "../../../src/utils/helpers";
import { SvgIcons } from "../../voyage-svg-icons/src/voyage-svg-icons";
import { FI_EVENT_CATEGORIES, FI_VESSEL_DETAILS_ACTIONS, TraceService } from "../../../src/services/trace-service";
import { getFormattedDataSource, speedTooltipText } from "../../../src/utils/utils";
import { AlarmState, AlarmType } from "../../../src/services/types/fleet-alarms-service.types";
import { VesselsModel } from "../../../src/models/vessels-model";
import { OperatorId, VesselVoyageVersion } from "../../voy-global-filters/src/types";
import { VesselTrack } from "../../../src/models/types/vessels-tracking-model.types";
import { VesselsTrackingModel } from "../../../src/models/vessels-tracking-model";
import { CurrentSchedule,Notification,PremiumVesselNotInNextPlatform,BprRejectInfo, NotificationResponse, NotificationType } from "./types";
import { VesselInfo } from "../../../src/models/types/vessels-model.types";
import { VesselPositionData } from "../../../src/services/types/position-service.types";
import { FleetAlarm } from "../../../src/models/types/voy-fleet-alarm-model.types";
import { showHandleAlarm } from "../../../src/utils/alarm-utils";
import { LatestNoPlanReminder } from "../../../src/services/types/plans-service.types";
import { AuthService, AuthorizationRoles } from "../../../src/services/auth-service";
import { ShoreContextEvent } from "../../../src/models/types/voyage-shore-context-model.types";
import { VoyageShoreContextModel } from "../../../src/models/voyage-shore-context-model";
import "../../voy-dot-menu/src/voy-dot-menu";
import { PositionsService } from '../../../src/services/positions-service';
import "../../voy-vessel-progress-route/src/voy-vessel-progress-route";
import { VoyFleetNotificationModel } from "../../../src/models/voy-fleet-notification-model";
import { RouteGeometry, VoyageRoute } from "../../../src/models/voyage-routing-model";
import { GeometryUtils } from "../../../src/utils/GeometryUtils";
import { Coordinate } from "ol/coordinate";
import { getStaticInfoWithTimeRemaining, ToolTip_Data_Source, Tooltip_Text } from "./helper";
import { TOOLTIP_TEXT, WEATHER_LIMIT_VALUES } from "../../../src/utils/weather-limits";
import {SchedulesService} from "../../../src/services/schedules-service";
import { setMapCenter } from "../../../src/utils/map-utils";
const env = (<any>window).appenv;
export enum DeviationType{
    Default = 'default',
    Deviation = 'deviation',
    LowDeviation = 'lowdeviation',
    IsAligned = 'aligned',
}

@customElement("voy-fleet-sub-view-vessel")
export class VoyFleetSubViewVessel extends LitElement {
    @property({ type: Number }) public imo?: number;

    @property({ attribute: false }) private _vessel?: VesselInfo;
    @property({ attribute: false }) private _schedule?: CurrentSchedule | null;
    @property({ attribute: false }) private _position?: VesselPositionData;
    @property({ attribute: false }) private _plan?: VoyagePlan;
    @property({ attribute: false }) private _speedElement: HTMLElement | null = null;
    @property({ attribute: false }) private _tracking: VesselTrack | null = null;
    @property({ attribute: false }) private _isNonMaerskVessel: boolean = false;
    @property({ attribute: false }) private _regularCapacity: number | null | undefined = undefined;
    //This properties added to handle `dismiss` option for selected alarm
    @property({ type: Array }) private _selectedAlarm: FleetAlarm | null = null;
    @property({ attribute: false }) private _handleAlarmPopupShow: boolean = false;
    @property({ attribute: false }) private _latestNoPlanReminder: LatestNoPlanReminder | null = null;
    @property({ attribute: false }) private _vesselLoader: boolean = false;
    @property({ attribute: false }) private _latestPosition: VesselPositionData | null = null;
    @property({ type:Boolean }) private  _timeLineVisible : boolean =  false;
    @property({ type:Boolean }) private  _isTableVisible : boolean =  false;

    @property({ attribute: false }) private _bprRejectInfo?: BprRejectInfo | null  = null;
    @property({ attribute: false }) private _showVesselMasterData: boolean = false;
    @property({type: Boolean}) hasWriteAccess: boolean = AuthService.userHasRole(AuthorizationRoles.WeatherLimitWrite);
    @property({type: Boolean}) hasReadAccess: boolean = AuthService.userHasRole(AuthorizationRoles.WeatherLimitRead);
    @property({ attribute: false }) private showBasicTag: boolean = false;

    constructor() {
        super();

        this._setVessel = this._setVessel.bind(this);
        this._setPlan = this._setPlan.bind(this);
        this._setSchedule = this._setSchedule.bind(this);
        this._setPosition = this._setPosition.bind(this);
        this._setVesselContext = this._setVesselContext.bind(this);
        this._goToSubView = this._goToSubView.bind(this);
        this._renderVesselAlarmIndicators = this._renderVesselAlarmIndicators.bind(this);
        this._renderPositionInfo = this._renderPositionInfo.bind(this);
        this._goToPortView = this._goToPortView.bind(this);
        this._calculatePlannedSpeed = this._calculatePlannedSpeed.bind(this);
        this._setTracking = this._setTracking.bind(this);
        this._renderVesselCardNavbar = this._renderVesselCardNavbar.bind(this);
        this._renderVesselSpeedColumn = this._renderVesselSpeedColumn.bind(this);
        this._renderDistanceColumn = this._renderDistanceColumn.bind(this);
        this._toggleAlarmPopup = this._toggleAlarmPopup.bind(this);
        this._setLatestNoPlanReminder = this._setLatestNoPlanReminder.bind(this);
        this._getLastReminderMessage = this._getLastReminderMessage.bind(this);
        this._toggleFollowVessel = this._toggleFollowVessel.bind(this);
        this._toggleTimeLine = this._toggleTimeLine.bind(this);
        this.toggleTable = this.toggleTable.bind(this);
        this._renderPlanInfo = this._renderPlanInfo.bind(this);
        this._setBprRejectInformation = this._setBprRejectInformation.bind(this);
    this._getRouteName = this._getRouteName.bind(this);
        if(localStorage.getItem("timeLineView")!==undefined) {
            this._timeLineVisible = localStorage.getItem("timeLineView")=="true";
        }
    }

    static styles = css`
        :host {
            font-family: MaerskText;
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
            color: #232222;
        }
        section, nav {
            display: flex;
            flex-direction: column;
            padding-top: 16px;
            row-gap: 16px;
        }
        section:nth-of-type(1) {
            row-gap: 24px;
            padding: 24px 16px 16px 16px;
            border-bottom: 1px solid var(--neutrals-grey-06);
            box-shadow: rgba(20, 20, 20, 0.25) 0px 1px 10px -1px;
   
        }
        .section-container {
            max-height: 50vh;
            overflow-y: auto;

        }
        .section-container-full {
            max-height: 57vh;
            overflow-y: auto;
        }

        nav {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            padding: 16px;
            row-gap: 3px;
            column-gap: 12px;
        }
        nav button {
            font-family: MaerskText;
            display: flex;
            column-gap: 7px;
            align-items: center;
            background: none;
            color: var(--voyage-blue-dark);
            border: none;
            flex: 1 0 calc(50% - 16px);
            text-align: left;
            cursor: pointer;
            padding: 0;
            height: 26px;
            line-height: 26px;
        }

        nav button #no-plan {
            display: none;
        } 
        
        nav button span {
            border-radius: 30px;
            padding: 1px;
            height: 26px;
            width: 26px;
            box-sizing: border-box;
            background-color: var(--voyage-alarm-red);
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--neutrals-grey-10);
        }

        nav button span[isBasic="true"][is-handled="true"] {
            background-color: var(--neutrals-grey-06);
            border: none;
        }
        nav button span[isWeather] {
            background-color: transparent;
            border: none;
        }

        nav button span[isWRAlert] {
            border: none;
            background-color: #ffd028;
        }

        nav button span[isBasic="false"] {
            background-color: var(--voyage-alarm-red);
            border-color: var(--primary-blue-900, blue);
            border: 2px solid var(--primary-blue-900, blue);
        }

        nav button span[isBasic="false"][is-handled="true"] {
            background-color: var(--neutrals-grey-06, grey);
            border-color: var(--primary-blue-900, blue);
            border: 2px solid var(--primary-blue-900, blue);
        }

        nav button span[is-handled="false"][isBasic="false"][hasReason="true"] {     
            background-color: var(--warning-yellow-10);
            border-color: var(--primary-blue-900, blue);
            border: 2px solid var(--primary-blue-900, blue);
        }

        /* nav button svg {
            width: 25px;
            fill: currentColor;
        } */
        .vessel-type {
            margin-top: 9px;
            font-size: 14px;
        }
        .row {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            align-items: flex-start;
            column-gap: 16px;
            padding: 0px 16px;
        }
        .row.schedule,
        .row.specs {
            flex-direction: row;
            row-gap: 16px;
            margin-bottom: 10px;
        }
        .row.schedule div,
        .row.specs div {
            flex: 1 0 calc(50% -  16px);
        }
        h5, p {
            margin: 0;
        }
        button.port-link {
            display: block;
            cursor: pointer;
            background: none;
            border: 0;
            padding:1px 0 0;
            font-size: 14px;
            line-height: 16px;
            text-align: left;
            font-weight: 900;
            padding: 5px;
            margin-left: 10px;
        }
        h5 {
            font-size: 12px;
            line-height: 16px;
        }
        h1 {
            font-size: 26px;
            line-height: 32px;
            margin: 0;
            font-weight: 400;
            font-family: MaerskHeadline;
            color: var(--neutrals-grey-02);
        }
        header {
            display: flex;
            flex-direction: row;
            column-gap: 4px;
        }
        header button {
            background: none;
            border: none;
            margin-top: 6px;
            cursor: pointer;
            padding: 0;
            margin-left: -6px;
            display: flex;
        }

        .last-position {
            display: flex;
            align-items: center;
            column-gap: 8px;
        }
        .last-position.error {
            color: var(--voyage-alarm-red);
        }
        .last-position svg {
            width: 16px;
            fill: currentColor;
        }
        .no-plan-alarm {
            font-size: 12px;
            line-height: 16px;
            color: var(--voyage-alarm-red);
        }
        .tooltip-for-speed {
           max-width: 5%;
           margin-left: 8px;
           position: relative;
           bottom: -5px;
        }
        .tooltip-for-speed svg {
            width: 20px;
            height: 20px;
            fill: var(--primary-blue-900, blue);
        }
        .tooltip {
           position: relative;
           top: 5px;
        }
        .tooltip svg {
            width: 20px;
            height: 20px;
            fill: var(--primary-blue-900, blue);
        }
        .box-with-background{
            background-color: var(--neutrals-grey-09);
            padding: 16px;
        }
        .container{
            border-bottom: 1px solid var(--neutrals-grey-06);
            border-bottom: 1px solid var(--neutrals-grey-06);
            box-shadow: var(--voyage-box-shadow) 0px 6px 10px;
        }
        .route-progress-wrapper {
            width: 100%;
            overflow-x: hidden;
        }

        .name-position-info {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .icons {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 15px;
            padding: 16px;
            padding: 16px;
            border-bottom: 1px solid var(--neutrals-grey-06);
        }

        .bg {
            display: flex;
            justify-content: center;
            border-radius: 20px;
            padding: 3px;
            font-size: 10px;
        }

        .gray-bg {
            background-color: #CFCFCF;
            width: 7em;
        }

        .red-bg{
            background-color: #E9B2B7;
            width: 4em
        }

        .green-bg {
            background-color: #C5E5C2;
            width: 4em;
        } 

        #crosstrack {
            padding: 0 1px 1px 0;
        }

        #speed {
            padding: 1px 0 0 1px;
        }


        .errormessage {
            font-family: MaerskText;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: center;
            padding: 24px 16px 24px 16px;
        }

        .option-icon {
            cursor: pointer;
        }
        .loader {
            padding-top: 16px;
            padding-bottom: 16px;
        }

        .icons div {
            margin-right: 24px;
        }

        .center {
            margin-top: 2px;
        }

        .email {
            margin-top: 4px;
        }

        .application-opt {
            margin-top: -2px;
            position: relative
        }

        .link {
            color: #0073AB;
            font-size: 14px;
            display: flex;
        }
        
        .navigate-icon {
            padding-left: 8px;
            margin-top: -2px;
            margin-right: -24px;
        }

        .custom-align {
            margin-left: -8px;
        }

        .premium-icon svg{
            height: 16px;
             width: 16px;
        }
        .plan-ahead {
            background: #FFD029;
            width: 12px;
            left: 11px;
            top: -4px;
            height: 12px;
            position: absolute;
            border-radius: 100%;
        }
        #tooltip-for-distance {
            position: relative;
            top: 5px;
        }
        #weather-table {
            display: grid;
            margin: 20px 0px;
            grid-template-columns: 115px 85px 85px;
            align-items: center;
            border-radius: 5px;
        }

        #weather-table > div {
            border-bottom: 1px solid var(--neutrals-grey-06, grey);
            padding: 9px;
            box-sizing: border-box;
            height: 100%;
        }
        .weather-box {
            padding: 14px;
            border-top: 1px solid var(--neutrals-grey-06, grey);
        }

        .cursor {
            cursor: pointer;
            display: flex;
            justify-content: space-between; 
            align-items: center; 
        }

        .text-and-tooltip {
            display: flex;
            align-items: center;
        }

        .text-and-tooltip h5 {
            margin: 0; 
        }

        .text-and-tooltip #tooltip-for-distance {
            margin-left: 8px; 
        }

        .cursor svg {
            margin-left: auto; 
        }
        
        .arrow svg {
            margin-left: auto; 
            height: 15px;
            margin-top: 10px;
            padding-left: 160px;
        }

        .legend {
            margin-top: 0;
            text-align: center;
            color: var(--neutrals-grey-02, black);
            font-size: 12px;
        }

        .legend-first{
            margin: 5px 0px;
        }

        .background{
            background-color: var(--neutrals-grey-09, grey);
        }
        
        .row-content{
            border-left: 1px solid var(--neutrals-grey-06, grey);
        }
        
        .column-content{
            border-right: 1px solid var(--neutrals-grey-06, grey);
        }
        
        .center{
            text-align: center;
            word-break: break-all;
            margin: initial;
        }
        .bpr-reject{
            font-weight:700;
            font-family: MaerskText;
            font-size: 12px;
            line-height: 16px;
        }
        .data-container {
            display: flex;
            justify-content: space-between;
            padding-top: 8px;
            margin-left: 8px;
        }

        .data-item {
            padding: 2px;
            border-radius: 5px;
        }

        .info-container {
            margin-left: 12px;
            padding-top: 10px;
            display: flex;
            gap: 16px;
            align-items: center;
        }

        .info-button {
            display: flex;
            align-items: center;
            background: none;
            border: none;
            font-size: 14px;
        }

        .time-schedules {
            background-color: var(--neutrals-grey-07, grey);
            border-radius: 10px;
            max-width: fit-content;
            font-size: 10.5px;
            margin-top: 7px;
            padding: 2px;
        }

        .icon-wrapper svg {
            width: 14px; 
            height: 14px;
            vertical-align: middle; 
            margin-bottom: 2px;
        }

        .plan-data {
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #dedede;
            padding: 0px 15px 15px;
            border-bottom: 1px solid #dedede;
        }

        .text-color{
            color: gray;
            margin-top: 5px;
        }

        .green-bold {
            color: green;
            font-weight: bold;
        }

        .route-type {
            display:flex;
            gap: 5px;
            align-items: center;
            margin-left: 10px;
        }

        .gmt-red {
            background-color: #FCDDE0;
            color: #a10000;
            padding: 2px 6px;
            border-radius: 10px;
            font-weight: bold;
        }

        .gmt-yellow {
            background-color: #FFF1C2;
            color: #a67c00;
            padding: 2px 6px;
            border-radius: 10px;
            font-weight: bold;
        }

        .gmt-green {
            background-color: #DCF6D9;
            color: #006600;
            padding: 2px 6px;
            border-radius: 10px;
            font-weight: bold;
        }

        .deviation {
            background-color: #FCDDE0;
            font-weight: bold;
        }

        .aligned {
            background-color: #DCF6D9;
            font-weight: bold;
        }

        .lowdeviation{
            background-color: #FFF1C2;
            font-weight: bold;
        }

        .basic-plan--icon {
            display: flex;
        }
       
        .basic-plan--label {
            margin: 0px 2px;
        }

        .custom-limits{
            height:20px;
            width:20px;
            fill:"black";
        }
        .left-padding {
            padding-left: 16px;
        }
    `
    toggleTable() {
        this._isTableVisible = !this._isTableVisible;
    }

    private _back() {
        UiStateModel!.setValue(UiStateModelParam.IMO);
        UiStateModel!.setValue(UiStateModelParam.FISubView);
        UiStateModel!.setValue(UiStateModelParam.ListView, 'vessels');
    }

    private _navigateTo(url: string, label: string): void {
        window.open(url, "_blank")
        let gaEventAction;

        switch (label) {
            case "Vessel Energy":
                gaEventAction = FI_VESSEL_DETAILS_ACTIONS.CLICKED_VESSEL_ENERGY;
                break
            default:
                gaEventAction = "Unknown Action";
                break
        }
        TraceService!.event(
            FI_EVENT_CATEGORIES.VESSEL_DETAILS,
            gaEventAction
        );
    }

    private async _setVessel(): Promise<void> {
        if (!this.imo) return;
        this._vesselLoader = true;
        this._vessel = await VesselsModel?.getVessel(this.imo)
        this._vesselLoader = false;
        this._isNonMaerskVessel = this._vessel?.operatorCode === OperatorId.NonMSK;
        await SchedulesService.getVesselTEU(this._vessel?.imoNo).then(res => {
            this._regularCapacity = res?.filter(r => r.mearskOperated !== this._isNonMaerskVessel)?.[0]?.teuCapacity
        });
    }

    private _setPosition(): void {
        if (!this.imo) return;
        this._position = VesselsTrackingModel!.allVesselPositions?.get(this.imo);
    }

    private isVesselOffline(plan: VoyagePlan | undefined): boolean {
        if (!plan) return false;
        return plan.application_type === "VVB" && plan.primaryvoyageplanningtool === 3 ? true : false
    }

    private _setPlan(): void {
        if (!this.imo) return;
        
        const plans = VoyagePlansModel!.getPlans(this.imo);

        // if vessel is offline, excel plan takes precedence over voyage planning
        if (plans?.has(PlanSource.EXCEL_PLAN) && this.isVesselOffline(plans?.get(PlanSource.EXCEL_PLAN))){
            this._plan = plans.get(PlanSource.EXCEL_PLAN)
        }
        else if (plans?.has(PlanSource.VOYAGE_PLANNING)) {
            this._plan = plans.get(PlanSource.VOYAGE_PLANNING)
        } else if (plans?.has(PlanSource.ECOVOYAGE)) {
            this._plan = plans.get(PlanSource.ECOVOYAGE)
        } else if (plans?.has(PlanSource.EXCEL_PLAN)) {
            this._plan = plans.get(PlanSource.EXCEL_PLAN)
        } else {
            this._plan = plans?.get(PlanSource.PASSAGE_PLAN)
        }
        VoyagePlansModel!.syncLatestNoPlanReminder(this.imo);
        this._setBprRejectInformation();
        this.showBasicTag = this.isVesselOffline(this._plan);
    }

    private async _setSchedule(): Promise<void> {
        if (!this.imo) return;

        const schedules = await VoyageSchedulesModel?.getScheduleFor(this.imo);
        const schedule = schedules?.find(schedule => schedule.active);

        if (!schedule) {
            this._schedule = null;
            return;
        }
        const departureTerminal = TerminalsModel!.getTerminal(schedule.departureTerminalCode);
        const departureActuals = schedule.departurePortCall?.GSIS?.actuals;

        const arrivalTerminal = TerminalsModel!.getTerminal(schedule.arrivalTerminalCode);
        const arrivalActuals = schedule.arrivalPortCall?.GSIS?.actuals;

        this._schedule = {
            inPort: !!schedule.inPort,
            arrival: {
                terminal: arrivalTerminal,
                terminalCode: schedule.arrivalTerminalCode,
                actual: !!arrivalActuals?.arrivalAt,
                timestamp: arrivalActuals?.arrivalAt ? arrivalActuals.arrivalAt : schedule.arrivalAt,
                pilotTimestamp: schedule.arrivalPortCall?.GSIS?.estimatedpilotboarding
            },
            departure: {
                terminal: departureTerminal,
                terminalCode: schedule.departureTerminalCode,
                actual: !!departureActuals?.departureAt,
                timestamp: departureActuals?.departureAt ? departureActuals.departureAt : schedule.departureAt,
                pilotTimestamp: schedule.departurePortCall?.GSIS?.estimatedpilotdropoff
            }
        }
    }


    private _renderPositionInfo(): TemplateResult {

        if (!this._position) {
            return html`<span class="bg gray-bg">No position</span>`;
        }
        let timeDiff: number = 0
        if(this._latestPosition) timeDiff = differenceInHours(new Date(), new Date(this._latestPosition!.timestamp));
        const dataSource = this._latestPosition?.source;
        const formattedDataSource = dataSource ? getFormattedDataSource(dataSource!) : "--";

        const className = timeDiff >= 4 ? "bg red-bg" : "bg green-bg";

        return html`<div>
            <span class=${className}>${prettyTimelapsed(this._latestPosition?.timestamp)}</span>

           <voyage-tooltip-proxy 
                text=${`Last position: ${prettyTimelapsed(this._latestPosition?.timestamp)} ago <br> Source: ${formattedDataSource}`}
                html-content
                .positionPriority=${["bottom"]}
                .tooltipInteraction=${false}
                >
                </voyage-tooltip-proxy>
        </div>`
    }

    private _goToPortView(cityId: string | null, gaLabel: string): void {
        if (!cityId) return;
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.PortView);
        UiStateModel!.setValue(UiStateModelParam.PORT, cityId);

        TraceService!.event(
            FI_EVENT_CATEGORIES.VESSEL_DETAILS,
            FI_VESSEL_DETAILS_ACTIONS.CLICKED_PORT_VIEW,
            `${gaLabel}: ${cityId}`
        );
    }

    private _renderSchedule(isPremium: boolean): TemplateResult {
        if (this._schedule === undefined || this._schedule === null) {
            return html`<p class="left-padding" >No schedule available</p>`
        }

        if (this._schedule.inPort) {
            return html`
                <p  class="left-padding">Vessel is in port: (${this._schedule.departure.terminal?.locationId || this._schedule.departure.terminalCode || "N/A"})</p>
            `
        }

        const pilotEtdCommunicated = GetFormattedLocalDateString(this._plan?.departurePilotEtd ?? 0, this._schedule.departure.terminal?.olsonTimezone!);
        const pilotEtdScheduled = GetFormattedLocalDateString(this._schedule.departure.pilotTimestamp ?? '', this._schedule.departure.terminal?.olsonTimezone!);
        const pilotEtaCommunicated = GetFormattedLocalDateString(this._plan?.arrivalPilotEta ?? '', this._schedule.arrival.terminal?.olsonTimezone!);
        const pilotEtaScheduled = GetFormattedLocalDateString(this._schedule.arrival.pilotTimestamp ?? '', this._schedule.arrival.terminal?.olsonTimezone!);

        //Basic plans don't submit eta berth and etd berth
        const departureCommunicated =  isPremium ? GetFormattedLocalDateString(this._plan?.etd ?? 0, this._schedule.departure.terminal?.olsonTimezone!): null; 
        const arrivalCommunicated = isPremium ? GetFormattedLocalDateString(this._plan?.eta ?? 0, this._schedule.arrival.terminal?.olsonTimezone!): null;
        const departureLT = GetFormattedLocalDateString((this._schedule.departure.timestamp).toString(), this._schedule.departure.terminal?.olsonTimezone!);
        const arrivalLT = GetFormattedLocalDateString((this._schedule.arrival.timestamp).toString(), this._schedule.arrival.terminal?.olsonTimezone!);
        
        return html`
            <div>
                <button data-test="dep-port-link" class="port-link" @click=${() => this._goToPortView(this._schedule?.departure.terminal?.cityId || null, "Departure Port")}>
                    ${this._schedule.departure.terminal?.city} (${this._schedule.departure.terminal?.locationId})
                </button>
                <div class="row schedule">
                    <div>
                        <p data-test="lbl-departure">
                            Departure Berth (Sch)
                        </p>
                        <p data-test="dep-ts" class="text-color">${departureCommunicated}</p>
                        <div data-test="depts" class="time-schedules label ${this.getDeviationClass(departureLT, departureCommunicated)}">
                                        <span class="icon-wrapper">${SvgIcons.lightExclamationCircle}
                                            <voyage-tooltip-proxy
                                            text=${ToolTip_Data_Source}
                                            html-content
                                            .positionPriority=${["bottom"]}>
                                            </voyage-tooltip-proxy>
                                        </span>
                            ${departureLT}${false ? html` <span class="utcWarn">UTC</span>` : "" } 
                        </div>
                    </div>
                    <div>
                        <p data-test="lbl-departure">Departure Pilot (Com)</p>
                        <p data-test="dep-ts" class="text-color">${pilotEtdCommunicated}</p>
                        <div data-test="depts" class="time-schedules label ${this.getDeviationClass(pilotEtdScheduled, pilotEtdCommunicated)}">
                                        <span class="icon-wrapper">${SvgIcons.lightExclamationCircle}
                                            <voyage-tooltip-proxy
                                            text=${ToolTip_Data_Source}
                                            html-content
                                            .positionPriority=${["bottom"]}>
                                            </voyage-tooltip-proxy>
                                        </span>
                            ${pilotEtdScheduled ? pilotEtdScheduled : "timestamp"}${false ? html` <span class="utcWarn">UTC</span>` : "" } 
                        </div>
                    </div>
                </div> 
                <button data-test="arr-port-link" class="port-link" @click=${() => this._goToPortView(this._schedule?.arrival.terminal?.cityId || null, "Arrival Port")}>
                    ${this._schedule.arrival.terminal?.city} (${this._schedule.arrival.terminal?.locationId})
                </button> 
                <div class="row schedule">
                    <div>
                        <p data-test="lbl-departure">Arrival Pilot (Com)</p>
                        <p data-test="dep-ts" class="text-color">${pilotEtaCommunicated}</p>
                        <div data-test="depts" class="time-schedules label ${this.getDeviationClass(pilotEtaScheduled, pilotEtaCommunicated)}">
                                        <span class="icon-wrapper">${SvgIcons.lightExclamationCircle}
                                            <voyage-tooltip-proxy
                                            text=${ToolTip_Data_Source}
                                            html-content
                                            .positionPriority=${["bottom"]}>
                                            </voyage-tooltip-proxy>
                                        </span>
                            ${pilotEtaScheduled ? pilotEtaScheduled : 'timestamp'}${false ? html` <span class="utcWarn">UTC</span>` : "" } 
                        </div>
                    </div>
                    <div>
                        <p data-test="lbl-arrival">Arrival Berth (Sch)</p>
                        <p data-test="arr-ts" class="text-color">${arrivalCommunicated}</p>
                        <div data-test="depts" class="time-schedules label ${this.getDeviationClass(arrivalLT, arrivalCommunicated)}">
                                        <span class="icon-wrapper">${SvgIcons.lightExclamationCircle}
                                            <voyage-tooltip-proxy
                                            text=${ToolTip_Data_Source}
                                            html-content
                                            .positionPriority=${["bottom"]}>
                                            </voyage-tooltip-proxy>
                                        </span>
                            ${arrivalLT}${this._schedule.arrival.actual ? html`- <span class="green-bold">Act</span>` : ""}${false ? html` <span class="utcWarn">UTC</span>` : "" } 
                        </div>
                    </div>
                </div>
            </div>
            <div class="plan-data">
                <div>
                    <p>Forward draft <span id="tooltip-for-distance" data-test="lbl-distance-tooltip-icon">${SvgIcons.lightQuestionCircle}
                        <voyage-tooltip-proxy
                            text=${Tooltip_Text}
                            html-content
                            .positionPriority=${["top"]}>
                        </voyage-tooltip-proxy>
                    </span></p>
                    <p class="text-color">${this._plan?.foreDraft ? `${this._plan.foreDraft} m` : ''}</p>
                </div>
                <div>
                    <p>Aft draft <span id="tooltip-for-distance" data-test="lbl-distance-tooltip-icon">${SvgIcons.lightQuestionCircle}
                        <voyage-tooltip-proxy
                            text=${Tooltip_Text}
                            html-content
                            .positionPriority=${["top"]}>
                        </voyage-tooltip-proxy>
                    </span></p>
                    <p class="text-color">${this._plan?.aftDraft ? `${this._plan?.aftDraft} m`: ''}</p>
                </div>
                <div>
                    <p>GMt <span id="tooltip-for-distance" data-test="lbl-distance-tooltip-icon">${SvgIcons.lightQuestionCircle}
                        <voyage-tooltip-proxy
                            text=${Tooltip_Text}
                            html-content
                            .positionPriority=${["top"]}>
                        </voyage-tooltip-proxy>
                    </span></p>
                    <p class="text-color ${this._getGmtClass(this._plan?.gmt)}" >${this._plan?.gmt ? `${this._plan?.gmt} M`: ''}</p>
                </div>
            </div>
        `
    }

    private _goToSubView(view: FiSubView) {
        UiStateModel!.setValue(UiStateModelParam.FISubView, view)
        let gaEventAction;

        switch (view) {
            case FiSubView.NearestPort:
                gaEventAction = FI_VESSEL_DETAILS_ACTIONS.CLICKED_DIVERT_TO;
                break
            case FiSubView.VesselAlarms:
                gaEventAction = FI_VESSEL_DETAILS_ACTIONS.CLICKED_ALARMS;
                break
            case FiSubView.VesselSchedule:
                gaEventAction = FI_VESSEL_DETAILS_ACTIONS.CLICKED_SCHEDULE;
                break
            case FiSubView.VesselPastTrail:
                gaEventAction = FI_VESSEL_DETAILS_ACTIONS.CLICKED_PAST_TRAIL;
                break
            default:
                gaEventAction = "Unknown Action";
                break
        }

        TraceService!.event(
            FI_EVENT_CATEGORIES.VESSEL_DETAILS,
            gaEventAction
        );
    }

    private _renderVesselAlarmIndicators(): TemplateResult[]  {
        if(!this._vessel) {
            return [html``];
        }
        const alarms = VoyFleetAlarmModel!.getVesselAlarmsBasicInfo(this._vessel.imoNo)

        const hasNoPlanAlarm = alarms.findIndex(a => a.alarmType === AlarmType.NoPlan) > -1

        if (hasNoPlanAlarm) {
            return [html`<span id="no-plan" >No plan</span>`];
        }

        const isBasic = this._vessel.vesselVersion === VesselVoyageVersion.Basic;
         const indicators: TemplateResult[] = alarms
            .filter(alarm => alarm.alarmState !== AlarmState.Acknowledged)
            .map(a => {
                const isHandled = a.alarmState === AlarmState.InProgress

                let isVesselReasonGiven:boolean = false;

                if( a.allAlarmLogs && a.allAlarmLogs.length > 0) {
                    isVesselReasonGiven = !!a.allAlarmLogs.find(el => el.reasonSource.toLowerCase() === "vessel" && el.reason != "")
                }
                
                switch (a.alarmType) {
                    case AlarmType.Speed: 
                        return html` 
                        <span id="speed" is-handled=${isHandled} hasReason=${isVesselReasonGiven} isBasic=${isBasic}>
                            ${isHandled || isVesselReasonGiven ? SvgIcons.customSpeedAlarmBlack : SvgIcons.customSpeedAlarm }
                            ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>
                        `
                    case AlarmType.Stoppage:
                        return html`<span is-handled=${isHandled} hasReason=${isVesselReasonGiven} isBasic=${isBasic}>
                            ${isHandled || isVesselReasonGiven ? SvgIcons.customStoppageAlarmBlack : SvgIcons.customStoppageAlarm }
                            ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>`
                    case AlarmType.Crosstrack:
                        return html`<span id="crosstrack" is-handled=${isHandled} hasReason=${isVesselReasonGiven} isBasic=${isBasic}>
                        ${isHandled || isVesselReasonGiven ? SvgIcons.customOfftrackAlarmBlack : SvgIcons.customOfftrackAlarm }
                        ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>`

                    case AlarmType.HeavyWeather:
                        return html`<span isWeather>
                            ${SvgIcons.heavyWeatherAlarm}
                            ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>`

                    case AlarmType.ParametricRoll:
                        return html`<span isWeather>
                            ${SvgIcons.parametricRollAlarm }
                            ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>`
                     case AlarmType.WRPerformanceAlert:
                        return html`<span isWRAlert> 
                            ${SvgIcons.weaterRoutingIcon}
                            ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>`
                     case AlarmType.WRSafetyAlert:
                        return html`<span isWRAlert>
                            ${SvgIcons.weaterRoutingIcon}
                            ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>`
                    case AlarmType.WRReject:
                        return html`<span isWRAlert>
                            ${SvgIcons.weaterRoutingIcon}
                            ${this._renderAlarmTooltip(a, isHandled, isBasic)}
                        </span>`
                    default:
                        return html``
                }
            })

        return indicators;
    }

    private _renderAlarmTooltip(alarm: FleetAlarm, isHandled: boolean, isBasic: boolean) {
        if(alarm.alarmType === AlarmType.WRPerformanceAlert || alarm.alarmType === AlarmType.WRSafetyAlert) {
            return html`<voyage-tooltip-proxy .positionPriority=${["right"]} .tooltipInteraction=${true} .innerComponent=${html`<span>Weather routing advice breaching Maersk safety limits/performance limits.</span>`}></voyage-tooltip-proxy>`
        }
        if(alarm.alarmType === AlarmType.WRReject) {
            return html`<voyage-tooltip-proxy .positionPriority=${["right"]} .tooltipInteraction=${true} .innerComponent=${html`<span>Weather routing advice rejected by Vessel.</span>`}></voyage-tooltip-proxy>`

        }
        //content for toolrip based on type
        let innerComponent
        let buttonsComponent
        const alarmType =  alarm.alarmType == AlarmType.Crosstrack ? "Offtrack" :  alarm.alarmType;
        const alarmStartDate = GetFormattedDateDayMonthTimeNoYear(alarm.startTs)

            if(isHandled) {
                if(alarm.alarmState === AlarmState.Acknowledged) {
                    buttonsComponent = html``
                } else {
                    buttonsComponent = html`
                    <style>
                        .buttons-wrapper {
                            margin-top: 8px;
                            display: flex;
                            flex-direction: row;
                            align-items: flex-end;
                            justify-content: flex-end;
                        }
                    </style>
                     ${isBasic ? html`<div class="buttons-wrapper"><mc-button appearance="neutral" label="Dismiss" fit="small" label="Dismiss" @click=${() => this._onAlarmDismiss(alarm, isBasic)}></mc-button></div>`
                        : html`
                            ${this._getAlarmReasonStatusFromVessel(alarm) ? 
                                html`<div class="buttons-wrapper"> <mc-button appearance="neutral" label="Dismiss" fit="small" label="Dismiss" @click=${() => this._onAlarmDismiss(alarm, isBasic)}></mc-button></div>`: 
                                nothing }
                        `}
                    `
                }
            } else {
                buttonsComponent = html`
                 <style>
                    .buttons-wrapper {
                        margin-top: 8px;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        gap: 16px;
                    }
                </style>
                ${isBasic 
                    ? html`
                        <div class="buttons-wrapper">
                            <mc-button appearance="neutral" fit="small" label="In progress" @click=${() => this._onAlarmInProgress(alarm.id)} type="button"></mc-button>
                            <mc-button appearance="neutral" fit="small" label="Dismiss" @click=${() => this._onAlarmDismiss(alarm, isBasic)} type="button"></mc-button>
                        </div>
                        `: html`
                            ${this._getAlarmReasonStatusFromVessel(alarm)
                             ? html`
                                    <div class="buttons-wrapper">
                                        <mc-button appearance="neutral" fit="small" label="In progress" @click=${() => this._onAlarmInProgress(alarm.id)} type="button"></mc-button>
                                        <mc-button appearance="neutral" fit="small" label="Dismiss" @click=${() => this._onAlarmDismiss(alarm, isBasic)} type="button"></mc-button>
                                     </div>
                                `
                                : nothing }
                            `}
                `
            }


        innerComponent = html`
        <style>
            .innerComponent .content .alarm-title {
                font-family: MaerskText;
                font-size: 12px;
                font-weight: 700;
                line-height: 16px;
                letter-spacing: 0em;
                text-align: left;
                padding: 0px;
                margin:0px;
                text-transform: capitalize;
            }
            .title-container {
                display: flex;
            }
            .innerComponent .content .alarm-body {
                font-family: MaerskText;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                letter-spacing: 0em;
                text-align: left;
                padding: 0px;
                margin-top: 0px;
                margin-bottom: 0px;
            }
            .innerComponent .content .reason {
                 margin-top: 4px;
                 margin-bottom: 4px;
            }
            .innerComponent .content .comment {
                 margin-bottom: 4px;
            }
            .innerComponent .content {
                margin: 0px;
            }
            .innerComponent .content {
                display: flex;
                justify-content: space-evenly;
                flex-direction: column;
            }
            .alarm-date {
                font-weight: 400;
            }
            
        </style>
        <div class="content">
        <p class="alarm-title">${alarmType}<span class = "alarm-date"> | ${alarmStartDate} UTC</span> </p>
            <p class="alarm-body">${getStaticInfoWithTimeRemaining(alarm)}</p>
            ${this._showReason(isBasic,alarm)? html`${this._renderReasonFromVessel(alarm)}` : nothing }
            ${(showHandleAlarm(alarm)) ? html`${buttonsComponent}` : nothing }
        </div>`

        return html`
        <voyage-tooltip-proxy .positionPriority=${["right"]} .tooltipInteraction=${true} .innerComponent=${innerComponent}></voyage-tooltip-proxy>`
    }
    private _showReason(isBasic: boolean, alarm: FleetAlarm) {
        if(!isBasic && !PremiumVesselNotInNextPlatform?.find(imo => imo === alarm?.imo) ) {
            if(alarm.alarmType !== AlarmType.HeavyWeather && alarm.alarmType !== AlarmType.ParametricRoll) {
                if(this._getAlarmReasonStatusFromVessel(alarm)) return true
            }
        }
        return false
    }

    private _getAlarmReasonStatusFromVessel(alarm: FleetAlarm){
        let vesselCommentStatus = false
        let vesselReason = []
        if(alarm.allAlarmLogs && alarm.allAlarmLogs[0].reasonSource?.toLowerCase() === "vessel") vesselCommentStatus = true
        // once user change the alarm status(inprogress to acknowledged - vessel submitted reason should be available in log)

        else if(alarm.allAlarmLogs && alarm.allAlarmLogs.length){
            vesselReason = alarm.allAlarmLogs.filter(log => log.reasonSource?.toLowerCase() === 'vessel')

            if(vesselReason.length) vesselCommentStatus = true
        }
        // CLF feature enabled for premium vessels now -excluded the vessels without next platform
        return vesselCommentStatus || PremiumVesselNotInNextPlatform?.find(imo => imo === alarm.imo);
    }

    private async _onAlarmDismiss(alarm: FleetAlarm, isBasic: Boolean) {
        // CLF feature enabled for premium vessels now -excluded the vessels without next platform
        if(isBasic || PremiumVesselNotInNextPlatform?.find(imo => imo === alarm.imo)) {
            this._handleAlarmPopupShow = true;
            this._selectedAlarm = alarm;
        } else {
            await VoyFleetAlarmModel!.updateAlarm(alarm?.id,AlarmState.Acknowledged, "", "");
            this.requestUpdate()
        }
       
    }

    private async _onAlarmInProgress(id: number){
        await VoyFleetAlarmModel!.updateAlarm(id, AlarmState.InProgress ,"");
        this.requestUpdate();
    }

    private _toggleAlarmPopup(e: CustomEvent): void {
        if(!e.detail.alarmId || !e.detail.alarmType) {
            throw new Error("failed to open handle alarm modal, missing alarmId or alarmType from event details")
        };

        this._handleAlarmPopupShow = !this._handleAlarmPopupShow;
    }

    private _handleAlarm = async (e: CustomEvent) => {
        if (!e.detail) {
            this._handleAlarmPopupShow = false;
            return;
        }

        await VoyFleetAlarmModel!.updateAlarm(this._selectedAlarm?.id!, e.detail.action, e.detail.selectedReason, e.detail.note);
        // need to rerender element
        this._handleAlarmPopupShow = false;
    }

    private async _setTracking() {
        if(!this.imo) return;
        this._tracking = VesselsTrackingModel!.getTracking(this.imo);
        if(this._tracking){
            const currentPosition = await PositionsService.currentPosition_VesselVoyage([this.imo]);
            this._latestPosition = currentPosition.length ? currentPosition[0]: null
        }
    }
    private _checkLatestPosition(trackdata:VesselTrack){
        if (!Array.isArray(trackdata.positions) || trackdata.positions.length === 0) {
            return null; // Return null for invalid input or empty array
          }
        
          let latestTimestamp = trackdata.positions[0].timestamp;
          let latestObject = trackdata.positions[0];
        
          // Sort the array of objects by timestamp in descending order
          trackdata.positions.sort((a, b)  =>  new Date(b.timestamp).valueOf() - new Date(a.timestamp).valueOf());
          // The first element in the sorted array will have the latest timestamp
          return trackdata.positions[0];
    }
    private _calculatePlannedSpeed(): number | undefined {
        if ( !this._plan ) return;

        // Excel plans
        if (this._plan.source === PlanSource.EXCEL_PLAN) {
            return this._plan.metadata?.speed; // excel planned speed is already in knots, so no conversion needed
        }
        
        // EcoVoyage and Voyage Planning
        if (!this._tracking) {
            return;
        }

        const route = this._plan.routes[0];
        if (!route) {
            return;
        }

        return this._plan.passagePlan!.calculatedValues!.routeAverageSpeed || undefined;
    }

    private _calculateTotalDistance(): number {
        let totalDist = 0;
        const KmToNM = 1 / 1.852; // Km -> Nautical miles
        const routeGeometry = this._plan?.routes[0].route_geometry as RouteGeometry;

        if(this._plan) {
            for(let i = 0; i < routeGeometry.length; i++) {
                if (routeGeometry[i].geometry.type === "LineString") {
                    totalDist += routeGeometry[i].properties?.distance || 0;
                }
            }
        }
        totalDist *= KmToNM;

        return totalDist;
    }

    private  _calculateRemainingDistance(): number {
        let remainingDistance = 0;
        if(this._plan && this._position) {
            const KmToNM = 1 / 1.852; // Km -> Nautical miles
            const voyageRoute: VoyageRoute = this._plan?.routes[0] as VoyageRoute;
            const routeGeometry = voyageRoute.route_geometry;
            const position: Coordinate = [this._position?.longitude, this._position?.latitude] as Coordinate;

            const nextWpIdx = GeometryUtils.getNextWaypointIndex(voyageRoute, position, -1);
            if(nextWpIdx < 0) {
                return 0;
            }

            const currentWpIdx = nextWpIdx - 1;
            if (currentWpIdx < 0) {
                return 0;
            }

            // calculate distance from current position to next waypoint
            const currWpGeometry = routeGeometry[currentWpIdx].geometry;
            const nextWP: Coordinate = (currWpGeometry.type === "LineString" ? currWpGeometry.coordinates[1] : currWpGeometry.coordinates) as Coordinate;
            const dists = CoordinatesUtils.calcDistance(position, nextWP);
            const distanceToNextWpNm = (routeGeometry[currentWpIdx].properties.leg_type === "GreatCircle") ? dists.gc : dists.rl;

            // calculate distance from next waypoint to destination
            let distanceToArrivalPilotPoint = 0;
            const startIdx = currWpGeometry.type === "LineString" ? currentWpIdx + 1 : currentWpIdx;
            
            for(let i = startIdx; i < routeGeometry.length; i++) {
                if (routeGeometry[i].geometry.type === "Point" && routeGeometry[i].properties.pilotPoint) {
                    break;
                } else if (routeGeometry[i].geometry.type === "LineString") {
                    distanceToArrivalPilotPoint += routeGeometry[i].properties.distance || 0;
                }
            }

            if (distanceToArrivalPilotPoint <= 0) {
                return 0;
            }

            remainingDistance = distanceToNextWpNm + (distanceToArrivalPilotPoint * KmToNM);

            return remainingDistance;
        }

        return remainingDistance;

    }
    
    mapValueToText(value : any, texts: any) {
        if (value !== null && value !== undefined && value >= 0 && value < texts.length) {
          return texts[value];
        }
        return '--';
      }

    private _getGmtClass(gmt: any) {
        if (gmt == null) return '';
        if (gmt <= 0.74) return 'gmt-red';
        if (gmt <= 0.99) return 'gmt-yellow';
        if (gmt <= 3.99) return 'gmt-green';
        if (gmt <= 5.99) return 'gmt-yellow';
        return 'gmt-red';
    }

    private getDeviationClass(scheduledTime: number | string | null , communicatedTime: number | string | null){
        if (!scheduledTime || !communicatedTime) return false;

        const scheduledDate =  new Date(scheduledTime);
        const communicatedDate = new Date(communicatedTime);
        const timeDiffInHours = Math.abs(scheduledDate.getTime() - communicatedDate.getTime()) / (1000 * 60 * 60);

        /*Colour Alignment for deviation
        More than 120 minutes of deviation == RED Colour
        Between 30 minutes to 120 minutes of deviation == YELLOW Colour
        Between 0 to 30 minutes of deviation == GREEN Colour
        */
    
        if (timeDiffInHours > 2)
            return DeviationType.Deviation;
        else if (timeDiffInHours > 0.5)
            return DeviationType.LowDeviation;
        else if (timeDiffInHours <= 0.5)
            return DeviationType.IsAligned

        return DeviationType.Default;
    }   

    private renderWeatherTable() {
        const weatherLimits = this._plan?.routes[0].route_info?.calculationInput?.weatherLimits;

        const weatherLimitOrder = WEATHER_LIMIT_VALUES;
        
        if (!weatherLimits) {
          return html``;
        }
        
        return weatherLimitOrder
        .filter(item => !item.key.includes('Period'))
        .map(item => {
            const key = item.key;
            const label = item.label;
            const mapper = item.mapper;
            const avoid = (weatherLimits[key as keyof typeof weatherLimits]).avoid;
            const warn = (weatherLimits[key as keyof typeof weatherLimits]).warn;
            const avoidValue = mapper ? this.mapValueToText(avoid, mapper) : (avoid ? avoid : '--');
            const warnValue = mapper ? this.mapValueToText(warn, mapper) : (warn ? warn : '--');

            const shouldPrintRow = warn || avoid;

        if (shouldPrintRow) {
        return html`
          <div class="row-content">${label}</div>
          <div class="center">${warnValue}</div>
          <div class="center column-content">${avoidValue}</div>
        `;
        }
        return null;
        }).filter(item => item !== null);
    }

    _renderBprInfo(field: string, label: string, isPremium: boolean) {
        if (this._bprRejectInfo?.[field as keyof BprRejectInfo] && isPremium && this._getRouteName() === "Own route") {
          return html`
            <span class="bpr-reject">${label}</span>&nbsp;${this._bprRejectInfo[field as keyof BprRejectInfo]}
          `;
        }
        return '';
      }
      

    render() {
        const { lat, lon } = this._position
            ? CoordinatesUtils.decimalToDegreesAndMinutes([this._position.longitude!, this._position.latitude!])
            : { lat: null, lon: null };
        const noPlanAlarm = VoyFleetAlarmModel!.getVesselAlarmsBasicInfo(this.imo || 0).find(a => a.alarmType === AlarmType.NoPlan)
        const noPlanAlarmMessage = !!noPlanAlarm ? prettyTimelapsed(noPlanAlarm.startTs) : "";
        const operator = this._vessel?.operatorCode === OperatorId.NonMSK ? 'Non-Maersk' : (this._vessel?.operatorCode || "--");
        const isUserInternal:boolean = AuthService.userHasRole(AuthorizationRoles.MaerskInternal);
        const isPremium:boolean = this._vessel?.vesselVersion === VesselVoyageVersion.Premium;
        const isCloud: boolean = this._vessel?.vesselVersion === VesselVoyageVersion.Cloud;

        if(this._vesselLoader) {
            return html`<div class="loader"><mc-loading-indicator></mc-loading-indicator></div>`;
        }
        
        if (!this._vesselLoader && !isUserInternal && !this._vessel) {
            return html`
        <div class="errormessage">Your account does not have permission to view vessel with IMO ${this._getUnauthorizedImo()} <br><br>Please contact your administrator to request access</div>`
        }
        let className = this._timeLineVisible ? "section-container" : "section-container-full"
        return html`
            <section>
                <div>
                    <div class="name-position-info">
                        <header>
                            <button @click=${this._back} data-test="back-button">${SvgIcons.customChevronLeft}</button>
                            <div class="title-container">
                                <h1 data-test="vessel-title"><span class="premium-icon" ?hidden=${!isPremium}>${SvgIcons.customPremiumVessel}</span>${this._vessel?.vesselName || "N/A"}</h1>
                                <div class="vessel-type" data-test='vessel-type'><strong>IMO:</strong> ${this._vessel?.imoNo || ""}, <strong>Vessel Code:</strong> ${this._vessel?.vesselCode}</div>
                            </div>
                        </header>
                        ${this._renderPositionInfo()}
                    </div>
                    <div class="info-container">

                        <div>
                                <button class="info-button" @click=${() => {this._showVesselMasterData = !this._showVesselMasterData}}>${SvgIcons.dotGrid} More info ${this._showVesselMasterData ? SvgIcons.caretUp : SvgIcons.caretDown}</button>
                                ${this._showVesselMasterData ? this._renderMasterData() : html``}
                        </div>
                        ${this.showBasicTag ? html ` 
                        <mc-tooltip open appearance="neutral-inverse" position="bottom-center" width="140px">
                            <mc-tag slot="trigger" icon="question-circle" appearance="info" fit="small" style="display: block">
                               <span slot="trailingicon" class="basic-plan--icon" style="color:#00243D; ">${SvgIcons.cloudoffline}</span>
                               <span class="basic-plan--label">Basic 2.0</span>
                        </mc-tag>
                        <div>
                            This cloud vessel is offline and now operating on Basic 2.0
                        </div>
                        </mc-tooltip>` : null}
                </div>
                </div>
                ${!!noPlanAlarm ? html`
                    <div class="no-plan-alarm">
                        No plan for ${noPlanAlarmMessage}
                        ${this._latestNoPlanReminder?.sentAt ? html`<div>${this._getLastReminderMessage(this._latestNoPlanReminder.sentAt) }</div>` : nothing}
                    </div>
                ` : nothing
                }
            </section>
            ${this._showShortcutIcons()}
            ${this._renderVesselCardNavbar()}
            ${this._isNonMaerskVessel ? html``
            : html`<div class="route-progress-wrapper">
                    <voy-vessel-progress-route .imo=${this.imo}></voy-vessel-progress-route>
                </div>`
            }
            <section class = ${className}>
                ${this._isNonMaerskVessel ? html``: 
                html`${this._renderSchedule(isPremium)}`}
                ${this._renderPlanInfo()}
                ${this._renderVesselSpeedColumn()}
                ${this._renderDistanceColumn()}
                <div class="row">
                    <h5 data-test="lbl-heading-course">Heading / Course</h5>
                    <p data-test="heading-course">
                        ${this._position && this._position.heading ? `${this._position.heading}º
                        (${CoordinatesUtils.getCardinalDirection(this._position.heading!)})` : "--"} /
                        ${this._position && this._position.course ? `${this._position.course}º
                        (${CoordinatesUtils.getCardinalDirection(this._position.course!)})` : "--"}
                    </p>
                </div>
                <div class="row">
                    <h5 data-test="lbl-lat-log">Latitude / Longitude</h5>
                    <p data-test="latitude-longitude">${lat || "--"} / ${lon || "--"}</p>
                </div>
                <div class="row schedule">
                    <div>
                        <h5 data-test="lbl-draft">Current draft (AIS)</h5>
                        <p data-test="draft">${this._vessel?.ais?.draught ? `${this._vessel.ais.draught} m` : "-- "}</p>
                    </div>
                    <div>
                        <h5 data-test="lbl-navigational-status">Navigational Status</h5>
                        <p data-test="navigational-status">${this._vessel?.navStatus || "--"}</p>
                </p>
              </div>
              <!-- Hiding the BPR rejection flow now -->
              <!-- <div>
                <h5>Current Route</h5>
                <p>${this._getRouteName()}</p>
                <p>${this._renderBprInfo('reason', 'Vessel reason:', isPremium)}</p>
                <p>${this._renderBprInfo('comments', 'Vessel comment:', isPremium)}</p>
                <p>${this._renderBprInfo('navWarningNo', 'Nav Warning Number:', isPremium)}</p>
              </div> -->
            </div>
            
                ${(isPremium || isCloud)? html `
                     <div class="row weather-box" @click=${this.toggleTable}>
                <div class="cursor">
                    <div class="text-and-tooltip">
                    <h5 data-test="lbl-distance-heading" >Weather Limits
                    <span id="tooltip-for-distance" data-test="lbl-distance-tooltip-icon">${SvgIcons.lightQuestionCircle}
                        <voyage-tooltip-proxy
                            text=${TOOLTIP_TEXT}
                            html-content
                            .positionPriority=${["top"]}>
                        </voyage-tooltip-proxy>
                    </span></h5>
                    </div>
                    <div class="arrow">
                    ${this._isTableVisible ? SvgIcons.lightChevronUp : SvgIcons.lightChevronDown}
                    </div>
                </div>
                ${this._isTableVisible ? html`
                    <div id="weather-table">
                        <div class="background"></div>
                        <div class="legend background">Vessel threshold</div>
                        <div class="legend legend-first background">Maersk <br>policy</div>
                        ${this.renderWeatherTable()}
                    </div>
                ` : ''}
                </div>
                ` : ``}
               
            </section>
            <voyage-tooltip position-priority='["top"]' .for=${this._speedElement}>${this._plan ? speedTooltipText(this._plan) : "Plan and planned speed for this vessel is currently not available"}</voyage-tooltip>
            <voy-handle-alarm-popup 
                .alarmEventType=${this._selectedAlarm?.alarmType}
                ?shown=${this._handleAlarmPopupShow}
                @close=${this._handleAlarm}>
            </voy-handle-alarm-popup> 
        `
    }
    private _getUnauthorizedImo(){
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        // Get the value of the "imo" parameter
        const imo = params.get('imo')
        // Check if the "imo" parameter exists
        return imo ? imo : ""

    }

    private _showWeatherLimits() {
        const showCustomLimit = new CustomEvent('open-custom-limits', {
            detail: {
                imo: this._vessel?.imoNo,
                isEditView: true
            },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(showCustomLimit);

    }
    private _showShortcutIcons(): TemplateResult {
        if (!this._vessel) return html``;
        const vesselEmail = VesselsTrackingModel?.maerskVesselEmail(this._vessel.imoNo);
        const openOutlook = () => {
            if (vesselEmail) {
            window.location.href = `mailto:${vesselEmail}`;
            }
        };

        const noSchedule = !this._schedule || this._schedule.inPort; // use this variable to hide email icon if required
        let tooltipContent = vesselEmail ? vesselEmail : "Email currently not available";
        const username: string = AuthService.getUserDetails()

            return html`
                <div class="icons">
                    <div class="option-icon email"
                        @click=${openOutlook}> 
                        ${SvgIcons.customEnvelope}
                        <voyage-tooltip-proxy
                            text=${tooltipContent}
                            .positionPriority=${["top"]}
                            .tooltipInteraction=${true}>
                        </voyage-tooltip-proxy>
                    </div>
                    <div class="option-icon"
                            @click=${()=>this._onPerformanceClicked()}> 
                            ${SvgIcons.performanceGraph}
                            <voyage-tooltip-proxy
                                text="Performance graphs"
                                .positionPriority=${["top"]}
                                .tooltipInteraction=${true}>
                            </voyage-tooltip-proxy>
                    </div>
                    <div class="option-icon custom-align application-opt">
                        <voy-dot-menu .dotMenuTitle=${SvgIcons.nvaigationIcon} .section = ${"application-link"}>            
                                <div class="link" ><span @click=${() => this._navigateTo(`${env.services.scfrontend.baseurl}/vessel/${this.imo}/overview`, "Vessel Energy")}>Energy  </span><span class="navigate-icon">${SvgIcons.customSquareArrowUpRight}</span></div>      
                        </voy-dot-menu>
                        <voyage-tooltip-proxy
                            text="See vessel in"
                            .positionPriority=${["top"]}
                            .tooltipInteraction=${true}>
                        </voyage-tooltip-proxy>
                    </div>
                    <div class="option-icon custom-align center" @click=${() => this._toggleFollowVessel()}> ${SvgIcons.customMyLocationIcon}
                    <voyage-tooltip-proxy text="Center map on vessel" html-content .positionPriority=${["top"]}></voyage-tooltip-proxy>
                     </div>
                        ${this.hasReadAccess && (this._vessel.vesselVersion === VesselVoyageVersion.Premium ||this._vessel.vesselVersion === VesselVoyageVersion.Cloud)  ? html`<div class="option-icon custom-limits"
                                @click=${()=>this._showWeatherLimits()}> 
                                ${SvgIcons.customWeather}
                                <voyage-tooltip-proxy
                                    text="custom weather limits"
                                    .positionPriority=${["top"]}
                                    .tooltipInteraction=${true}>
                                </voyage-tooltip-proxy>
                        </div>`: nothing}
                </div>
                </div>
            `;
    }

    private _renderVesselCardNavbar(): TemplateResult {
        return html`
            <div class="container">
                <nav>
                    ${this._isNonMaerskVessel ? html`
                        <button data-test="btn-time-interval" @click=${() => this._goToSubView(FiSubView.VesselPastTrail)}>Past trail</button>
                        <button data-test="btn-nearest-port" @click=${() => this._goToSubView(FiSubView.NearestPort)}>Divert to</button>
                    `: html`
                        <button @click=${() => this._goToSubView(FiSubView.VesselAlarms)}>Alarms ${this._renderVesselAlarmIndicators()}</button>
                        <button data-test="btn-nearest-port" @click=${() => this._goToSubView(FiSubView.NearestPort)}>Divert to</button>
                        <button data-test="btn-schedule" @click=${() => this._goToSubView(FiSubView.VesselSchedule)}>Schedule</button>
                        <button data-test="btn-time-interval" @click=${() => this._goToSubView(FiSubView.VesselPastTrail)}>Past trail</button>
                    `}  
                </nav>
            </div>
        `
    }

    private _renderVesselSpeedColumn(): TemplateResult {
        const plannedSpeed = this._calculatePlannedSpeed();

        return html `
            <div class="row">
                ${this._isNonMaerskVessel ? html `
                    <h5 data-test="lbl-speed"> Current speed</h5>
                    <p data-test="speeds"> ${this._position?.sog ? `${this._position?.sog.toFixed(1)} kt` : "--"}</p>
                ` : html `
                    <h5 data-test="lbl-speed" >Planned speed / Current speed <span class="tooltip-for-speed" data-test="lbl-speed-tooltip-icon">${SvgIcons.lightQuestionCircle}</span></h5>
                    <p data-test="speeds">
                        ${plannedSpeed ? `${plannedSpeed.toFixed(1)} kt` : '--'} /
                        ${this._position?.sog ? `${this._position?.sog.toFixed(1)} kt` : "--"}
                    </p>
                `}
            </div>
        `
    }

    private _renderDistanceColumn(): TemplateResult {
        const totalDist = (this._plan?.passagePlan?.calculatedValues?.pilotToPilotDistance) ? this._plan?.passagePlan?.calculatedValues?.pilotToPilotDistance as number : this._calculateTotalDistance();
        const remainingDist = this._calculateRemainingDistance();
        const sailedDist = (remainingDist > 0)? totalDist - remainingDist: 0;

        return html `
            <div class="row">
                <h5 data-test="lbl-distance-heading" >Total Distance 
                    <span id="tooltip-for-distance" data-test="lbl-distance-tooltip-icon">${SvgIcons.lightQuestionCircle}
                        <voyage-tooltip-proxy
                            text="Pilot to Pilot distance"
                            html-content
                            .positionPriority=${["top"]}>
                        </voyage-tooltip-proxy>
                    </span> / Remaining Distance / Sailed Distance</h5>
                <p data-test="lbl-distance">
                    ${totalDist ? `${totalDist.toFixed(1)} Nm` : '--'} /
                    ${remainingDist && remainingDist < totalDist ? `${remainingDist.toFixed(1)} Nm` : '--'} /
                    ${sailedDist && sailedDist > 0 ? `${sailedDist.toFixed(1)} Nm` : '--'}
                </p>
            </div>
        `
    }

    private _renderReasonFromVessel(alarm: FleetAlarm) {
        let reasonFromVessels = alarm?.allAlarmLogs?.filter(log => log.reasonSource?.toLowerCase() === "vessel")
        if(reasonFromVessels?.length && !PremiumVesselNotInNextPlatform?.find(imo => imo === alarm.imo) ){
            return html`
            <p class="alarm-body reason">Reason by vessel: ${GetUTCTimestamp(alarm?.startTs||"")} UTC ${reasonFromVessels[0].reason}</p>
            ${reasonFromVessels[0].note ? html`<p class="alarm-body comment">Comment: ${reasonFromVessels[0].note}</p>`: nothing }
            `
        }
        else if(alarm.alarmLogs && alarm.alarmLogs.length){
            let replyFromVessel =  alarm.alarmLogs?.filter(log => log.reasonSource?.toLowerCase() === "vessel")
            if(replyFromVessel?.length) {
                return html`
                 <p class="alarm-body reason">Reason by vessel: ${GetUTCTimestamp(replyFromVessel[0]?.createdAt||"")} UTC ${replyFromVessel[0]?.reason}</p>
                 ${replyFromVessel[0]?.note ? html`<p class="alarm-body comment">Comment: ${replyFromVessel[0]?.note}</p>`: nothing }
                 `
            }
        }       
    }

    private _renderMasterData() {
        const isUserInternal:boolean = AuthService.userHasRole(AuthorizationRoles.MaerskInternal);
        const operator = this._vessel?.operatorCode === OperatorId.NonMSK ? 'Non-Maersk' : (this._vessel?.operatorCode || "--");
        return html`
            <div class="data-container">
                <div class="data-row">
                    <div class="data-item"><strong>Service:</strong> ${this._vessel?.serviceCode || "--"}</div>
                    <div class="data-item"><strong>Breadth:</strong> ${this._vessel?.ais?.width ? `${this._vessel.ais.width} m` : "--"}</div>
                    ${!isUserInternal ? html`` : html`<div class="data-item"><strong>Operator:</strong> ${operator}</div>`}
                    <div class="data-item"><strong>Build year:</strong> ${this._vessel?.ais?.yearBuilt || "--"}</div>
                    ${this._isNonMaerskVessel ? html`` : html`<div class="data-item"><strong>Vessel Class:</strong> ${this._vessel?.vesselClass || "--"}</div>`}
                </div>
                <div class="data-row">
                    <div class="data-item"><strong>TEU</strong> (nominal)<strong>:</strong> ${this._regularCapacity || "--"}</div>
                    <div class="data-item"><strong>Length overall:</strong> ${this._vessel?.ais?.length ? `${this._vessel?.ais.length} m` : "--"}</div>
                    ${this._isNonMaerskVessel || !isUserInternal ? html`` : html`<div class="data-item"><strong>Fleet group:</strong> ${this._vessel?.fg?.toUpperCase() || "--"}</div>`}
                    <div class="data-item"><strong>Flag:</strong> ${this._vessel?.ais?.flag || "--"}</div>
                    <div class="data-item"><strong>Type:</strong> ${this._vessel?.vesselType || "--"}</div>
                </div>
            </div>
        `
    }

    private _onPerformanceClicked() {
        UiStateModel!.toggleElementVisibility(UiElements.PerformanceGraphs);
        TraceService!.event(
            FI_EVENT_CATEGORIES.VESSEL_DETAILS,
            FI_VESSEL_DETAILS_ACTIONS.CLICKED_PERFORMANCE
        );
    }

    private _setVesselContext() {
        setMapCenter();
        this._setVessel();
        this._setPlan();
        this._setPosition();
        this._setSchedule();
        this._setTracking();
        
    }

    private _setLatestNoPlanReminder() {
        if (!this.imo) {
            return;
        }
        this._latestNoPlanReminder = VoyagePlansModel!.getLatestNoPlanReminder(this.imo);
    }

    private _getLastReminderMessage(dateString: string): string {
        const reminderDate = new Date(dateString);
        const currentDate: Date = new Date();
        const timeDifference = Math.abs(currentDate.getTime() - reminderDate.getTime()) / 1000 / 60; // Convert milliseconds to minutes
      
        if (timeDifference < 60) {
          const minutes = Math.floor(timeDifference);
          return `Last reminder sent ${minutes} min. ago`;
        } else if (timeDifference < 60 * 2) {
          return 'Last reminder sent 1 hour ago';
        } else {
          const hours = Math.floor(timeDifference / 60);
          return `Last reminder sent ${hours} hours ago`;
        }
      }

    firstUpdated() {
        // Bootstrapping
        this._setVesselContext();
        this._speedElement = this.shadowRoot!.querySelector(".tooltip-for-speed");
    }

    updated(changedProperties: PropertyValues) {
        if (changedProperties.has('imo')) {
            this._setVesselContext();
        }
        super.update(changedProperties); 
    }

    connectedCallback() {
        super.connectedCallback();

        VoyageSchedulesModel!.addEventListener('schedule-states-updated', this._setSchedule);
        VoyagePlansModel!.addEventListener('plans-updated', this._setPlan);
        VoyagePlansModel!.addEventListener('latest-reminders-updated', this._setLatestNoPlanReminder);
        VesselsTrackingModel!.addEventListener('positions-updated', this._setPosition);
        VesselsTrackingModel!.addEventListener('tracking-updated', this._setTracking);
        VesselsModel!.addEventListener('vessels-updated', this._setVessel);
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);  

    }

    private async _setBprRejectInformation() {
        if (!this.imo || !this._plan) {
            this._bprRejectInfo = null;
            return;
        }
    
        try {
            const response: Notification[] | null | undefined = await VoyFleetNotificationModel?.fetchBprInformationNotification(this.imo, NotificationType.reject);
            if (!response?.length) {
                this._bprRejectInfo = null;
                return;
            }
    
            let mostRecentNotification: Notification | null = null;
            let mostRecentResponse: NotificationResponse | null = null;
            for (const notification of response) {
                const notificationData = JSON.parse(notification.data);
                const isNotificationFromVessel = notification.source === 'Vessel';
                const isMatchingScheduleId = notificationData.scheduleId === this._plan?.scheduleId;
                const isNewerNotification = !mostRecentNotification || new Date(notification.created_at) > new Date(mostRecentNotification.created_at);
    
                if (isNotificationFromVessel && isMatchingScheduleId) {
                    if (isNewerNotification) {
                        mostRecentNotification = notification;
                        mostRecentResponse = null;  
                    }
                }
            }
            if (mostRecentNotification) {
                for (const response of mostRecentNotification.notification_responses) {
                    const isNewerResponse = !mostRecentResponse || new Date(response.created_at) > new Date(mostRecentResponse.created_at);

                    if (isNewerResponse) {
                        mostRecentResponse = response;
                    }
                }
            }
            if (mostRecentResponse) {
                this._bprRejectInfo = JSON.parse(mostRecentResponse.data);
            } else {
                this._bprRejectInfo = null;
            }
    
        } catch (error) {
            this._bprRejectInfo = null;
        }
    }
    
    
    private _getRouteName() {
    return this._plan?.routes[this._plan?.selectedRouteIndex]?.name ?? this._plan?.routes[this._plan?.selectedRouteIndex]?.routeCreatedBy == "system" ? "Star route" : "Own route"
    }
    disconnectedCallback() {
        VoyageSchedulesModel!.removeEventListener('schedule-states-updated', this._setSchedule);
        VoyagePlansModel!.removeEventListener('plans-updated', this._setPlan);
        VoyagePlansModel!.removeEventListener('latest-reminders-updated', this._setLatestNoPlanReminder);
        VesselsTrackingModel!.removeEventListener('positions-updated', this._setPosition);
        VesselsTrackingModel!.removeEventListener('tracking-updated', this._setTracking);
        VesselsModel!.removeEventListener('vessels-updated', this._setVessel);
    }

    private _toggleFollowVessel(){
        VesselsTrackingModel?.centerMapOnVessel();
    }

    private _toggleTimeLine():void {
        this._timeLineVisible = !this._timeLineVisible
    }

    _renderPlanInfo(){
        if(!(this._plan && this._plan.update_dtm)) {
            return;
        }
        const planUpdatedAt = getFormattedDateUTC(new Date(this._plan.update_dtm));
        
        if(!(this._plan && this._plan?.routes && this._plan?.routes.length)) {
            return;
        }
        const route  = this._plan.routes[0];
        const routeType = route.routeCreatedBy?.toLocaleUpperCase() === 'system' ? 'Star route' : 'Own route';

        const subscription = route?.route_info?.weather?.subscriptions?.[0];
        let forecastImportedAt = '--';
        if(subscription && subscription.importedAt) {
            forecastImportedAt = getFormattedDateUTC(new Date(subscription?.importedAt));
        }
        
        return html `
            <div class="route-type">
               <p><h5 data-test="lbl-speed">Route type: </h5>${routeType == 'Own route' ? SvgIcons.captainIcon : SvgIcons.starIcon}${routeType}</p>
            </div>
            <div class="row">
               <h5 data-test="lbl-speed">Last Passage Plan updated by vessel/Last weather forecast update on vessel</h5>
                <p data-test="speeds">${planUpdatedAt}/${forecastImportedAt}</p>
            </div>
        `
    }
}
